import React, { useEffect } from 'react'
import styled from 'styled-components'

export default function ImageModal({
  src,
  isOpen,
  onClose
}: {
  src: string,
  isOpen: boolean,
  onClose: () => void
}) {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    } else {
      document.removeEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  return (
    <Modal
      className="image-modal"
      $isOpen={isOpen}
      onClick={onClose}
    >
      <div className="image-modal-content"
        onClick={e => e.stopPropagation()}
      >
        <img src={src} alt='' />
      </div>
    </Modal>
  )
}

const Modal = styled.div.attrs(({ className }) => ({ className }))<{
  $isOpen: boolean
}>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
  position: fixed;
  z-index: 200;
  padding-top: 100px;
  padding-bottom: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);

  .image-modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 800px;
  }

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    padding-top: 75px;
    padding-bottom: 75px;

    .image-modal-content {
      width: 90%;
    }
  }
`;

